import { Button, ButtonType } from 'modules/ui/button';
import { Flex } from 'modules/ui/flex';
import { NavigationAndActionInfoSmall } from 'modules/ui/icons';
import { theme } from 'modules/ui/theme';
import React, { ReactNode, useMemo } from 'react';
import { InfoCardType } from './InfoCardType';
import {
  ButtonWrapper,
  CardIcon,
  CardContent,
  CardWrapper,
  CardDescription,
  StyledHeadlineTitle,
  StyledParagraphTitle,
} from './styled';

export interface InfoCardProps {
  type?: InfoCardType;
  title: string;
  description?: ReactNode | string;
  icon?: ReactNode;
  backgroundColor?: string;
  backgroundImage?: string;
  buttonText?: string;
  onClick?: () => void;
}

export const InfoCard: React.FC<InfoCardProps> = ({
  title,
  description,
  icon = <NavigationAndActionInfoSmall />,
  type = InfoCardType.CardSmallPlain,
  buttonText,
  backgroundColor,
  backgroundImage,
  onClick,
}) => {
  const buttonType = useMemo(
    () =>
      type === InfoCardType.CardWidePlain ||
      type === InfoCardType.CardWidePlainTeal
        ? ButtonType.Primary
        : ButtonType.Text,
    [type],
  );

  const cardIcon = useMemo(
    () =>
      icon &&
      (type === InfoCardType.CardSmallPlain ||
        type === InfoCardType.CardWidePlain ||
        type === InfoCardType.CardWidePlainTeal) ? (
        <CardIcon
          color={
            type === InfoCardType.CardWidePlainTeal
              ? theme.colors.primaryW
              : theme.colors.primaryK10
          }>
          {icon}
        </CardIcon>
      ) : (
        <></>
      ),
    [icon, type],
  );

  const cardTitle = useMemo(
    () =>
      type === InfoCardType.CardSmallPlain ||
      type === InfoCardType.CardWidePlain ||
      type === InfoCardType.CardWidePlainTeal ? (
        <StyledParagraphTitle>{title}</StyledParagraphTitle>
      ) : (
        <StyledHeadlineTitle cardType={type}>{title}</StyledHeadlineTitle>
      ),
    [type, title],
  );

  return (
    <CardWrapper
      cardType={type}
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}>
      {cardIcon}
      <CardContent cardType={type}>
        <Flex>
          {cardTitle}
          <CardDescription cardType={type}>{description}</CardDescription>
        </Flex>

        {buttonText && (
          <ButtonWrapper cardType={type}>
            <Button
              type={buttonType}
              text={buttonText}
              onClick={onClick}
              color={
                type === InfoCardType.CardSmallVisual ||
                type === InfoCardType.CardWideVisual
                  ? theme.colors.primaryW
                  : undefined
              }
            />
          </ButtonWrapper>
        )}
      </CardContent>
    </CardWrapper>
  );
};
